import { weekdayDateLabel } from "./dateRange";
import { formatDuration } from "./formatters";

export default function ActivityByUserDay({
  dates = [],
  rows = [],
  onSelectUser,
}) {
  if (!dates.length) {
    return <p className="pa-empty">No days in this period.</p>;
  }
  if (!rows.length) {
    return <p className="pa-empty">No one is signed in right now.</p>;
  }

  const maxSeconds = Math.max(
    0,
    ...rows.flatMap((row) => dates.map((date) => row.cells?.[date] || 0)),
  );

  return (
    <div className="pa-heatmap-wrap">
      <table className="pa-heatmap">
        <thead>
          <tr>
            <th>User</th>
            {dates.map((date) => (
              <th key={date}>{weekdayDateLabel(date)}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => {
            const label = row.userName || row.userId || "—";
            const canSelect = typeof onSelectUser === "function" && row.userId;
            return (
              <tr key={row.userId || label}>
                <th scope="row">
                  {canSelect ? (
                    <button
                      type="button"
                      className="pa-user-link"
                      onClick={() => onSelectUser(row)}
                    >
                      {label}
                    </button>
                  ) : (
                    label
                  )}
                </th>
                {dates.map((date) => {
                  const seconds = row.cells?.[date] || 0;
                  const intensity = maxSeconds ? seconds / maxSeconds : 0;
                  return (
                    <td key={`${row.userId}-${date}`}>
                      <span
                        className="pa-heatmap__cell"
                        title={`${label} · ${weekdayDateLabel(date)} · ${formatDuration(seconds)}`}
                        style={{
                          background: seconds
                            ? `rgba(43, 109, 242, ${0.12 + intensity * 0.72})`
                            : "#f8fafc",
                          color: intensity > 0.55 ? "#ffffff" : "#1e3a8a",
                        }}
                      >
                        {seconds ? formatShort(seconds) : "—"}
                      </span>
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

function formatShort(totalSeconds) {
  const seconds = Math.max(0, Number(totalSeconds) || 0);
  if (seconds < 60) return "<1m";
  const hours = seconds / 3600;
  if (hours >= 1) {
    const rounded = Math.round(hours * 10) / 10;
    return Number.isInteger(rounded) ? `${rounded}h` : `${rounded.toFixed(1)}h`;
  }
  return `${Math.round(seconds / 60)}m`;
}
